import { Dispatch } from 'redux'
import { ConstantsStoreService } from './service'
import { FETCH_CONSTANTS_REQUEST, FETCH_CONSTANTS_SUCCESS, FETCH_CONSTANTS_FAILURE } from './types'

const ls = require('local-storage')

const requested = () => {
  return {
    type: FETCH_CONSTANTS_REQUEST,
  }
}

const loaded = (newData: any) => {
  return {
    type: FETCH_CONSTANTS_SUCCESS,
    payload: newData,
  }
}

const error = (errorData: any) => {
  return {
    type: FETCH_CONSTANTS_FAILURE,
    payload: errorData,
  }
}

export const ConstantsAction =
  ({ onSuccess = (data?: any) => {}, onError = () => {} }) =>
  (dispatch: Dispatch) => {
    dispatch(requested())
    ConstantsStoreService()
      .then((data) => {
        const DEBUG = process.env.REACT_APP_DEBUG
        const debug = ls.get('loglevel:webpack-dev-server')

        if (debug) {
          Object.keys(data.data).map((key) => {
            const param = { [key]: ls.get(`_${key}`) }
            if (param?.[key] !== null) {
              Object.assign(data.data, param)
              if (DEBUG) console.warn(`Warning! Constant "${key}" are changed.`)
            }
            return param
          })
        }

        dispatch(loaded(data.data))
        onSuccess(data.data)
      })
      .catch((err) => {
        if (process.env.DEBUG) console.log('Info service error', err)
        dispatch(error(err))
        onError()
      })

    // const data = {
    //   DOC_PERIOD_START: 1662973200000,
    //   IS_DOC_REGISTER_END: false,
    //   IS_ACTION_START: false,
    //   DEBUG: false,
    //   CAPTCHA_SITEKEY: '6Lc5fv0gAAAAAF7tFSWddFtNhsZ2y8vzq8pLTdbw',
    //   IS_PERSONAL_END: false,
    //   PROFILE: 'test',
    //   PERSONAL_END_DATE: 1670101199000,
    //   IS_ACTION_END: false,
    //   ACTION_PERIOD_START: 1662973200000,
    //   NOW: 1662470761050,
    //   ACTION_PERIOD_END: 1669409999000,
    //   DOC_PERIOD_END: 1669409999000,
    // }
    // dispatch(loaded(data))
    // onSuccess(data)
  }
